import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`Route error in ${this.props.routeName}:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <RouteErrorFallback routeName={this.props.routeName} />;
    }

    return this.props.children;
  }
}

const RouteErrorFallback = ({ routeName }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: '#012d50',
      color: 'white',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>⚠️</div>
      <h2 style={{ marginBottom: '1rem' }}>
        {language === 'en' ? 'Page Error' : 'Σφάλμα Σελίδας'}
      </h2>
      <p style={{ marginBottom: '2rem', maxWidth: '500px' }}>
        {language === 'en' 
          ? `There was a problem loading the ${routeName} page. This has been reported and we'll fix it soon.`
          : `Υπήρξε πρόβλημα με τη φόρτωση της σελίδας ${routeName}. Το έχουμε αναφέρει και θα το διορθώσουμε σύντομα.`}
      </p>
      <div style={{ display: 'flex', gap: '1rem' }}>
        <button 
          onClick={() => navigate('/')}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: '#0ea5e9',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '1rem'
          }}
        >
          {language === 'en' ? 'Go Home' : 'Αρχική'}
        </button>
        <button 
          onClick={() => window.location.reload()}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: 'transparent',
            color: 'white',
            border: '1px solid white',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '1rem'
          }}
        >
          {language === 'en' ? 'Reload' : 'Επαναφόρτωση'}
        </button>
      </div>
    </div>
  );
};

export default RouteErrorBoundary;